import React from 'react';
import styled from 'styled-components';

const Styled404 = styled.div`
    text-align: center;

    height: 100vh;

    img {
        margin-top: 5vh;
        height: 70vh;
    }
`;

const NotFound: React.FunctionComponent = () => {
    return (
        <div>
            <Styled404>
                <img alt="page not found" src="/assets/images/notfound.svg" />
                <h1>Page not found</h1>
                <p>Please go back and try again</p>
            </Styled404>
        </div>
    );
};

export default NotFound;
